import React, {useState, useEffect, useRef} from 'react';
import {
  View, 
  FlatList, 
  ActivityIndicator, 
  Text, 
  TouchableOpacity, 
  Image, 
  Dimensions, 
  StyleSheet, 
  Modal, 
  TextInput
} from 'react-native';
import {Button} from 'react-bootstrap';
import {listApplicableAddons, getGenreWiseChannelsByBouquet} from '../../network/Network';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner'
import {Card} from 'react-native-elements';

const HEIGHT = Dimensions.get('window').height
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

const AddOnsListComponent = (props) => {

  const [channelPacks, setChannelPacks] = useState([]);
  const [packBackup, setPackBackup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [channelData, setChannelData] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [modalLoading, setModalLoading] = useState([]);
  const [selectedIds, setSelectedIds] = useState([0]);
  
  useEffect(() => {
    setLoading(true);
    listApplicableAddons()
      .then((json) => {
        setChannelPacks(json.data);
        setPackBackup(json.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setSelectedIds(props.cartItems);
    return () =>{ 
    }
  }, [props.cartItems]);

  const getChannelList = (bouque_id) => {
    setModalLoading(true);
    getGenreWiseChannelsByBouquet(bouque_id)
    .then((json) => {
      console.log(json);
      setChannelData(json);
      setChannelList(json.data.channels);
      setModalLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setModalLoading(false);
    });
  }

  const selectThisPack = (item) => {
    let copy = [...selectedIds];
    if(copy.includes(item.id)){
      copy.splice(copy.indexOf(item.id), 1);
      props.removeFromCart(item.id);
    } else{
      copy.push(item.id);
      const obj = {
        id: item.id,
        pack_name: item.description,
        pack_type: item.type_lbl,
        mrp: item.mrp
      }
      props.addToCart(obj);
    }
    setSelectedIds(copy); 
  }

  const searchItems = text => {
    if(text != ''){
      const newData = channelPacks.filter(item => {
        const textData = text.trim().toUpperCase();
        return item.name.indexOf(textData) > -1;
      });
      setChannelPacks(newData);
    } else{
      setChannelPacks(packBackup); 
    }
  };

  const calculateNumOfColumns = () => {
    if(isWeb){
      return Math.round((WIDTH - 128)/320)
    } else{
      return Math.round(WIDTH/350);
    }
  }

  const renderItem = ({item, index}) => {
    const isSelected = selectedIds.includes(item.id);
    const shadowColor = isSelected ? `${0}px ${0}px ${12}px ${'#3C7F0EBB'}` : `${0}px ${0}px ${12}px ${'#8080803B'}`;
    return (
      <View style={[styles.box, { boxShadow: shadowColor } ]}>
        <View style={styles.headerHolder}>
          <Text style={styles.boxHeader}>{item.description}</Text>
          <TouchableOpacity
            onPress={() => {
              getChannelList(item.id);
              setModalVisible(true);
            }}>
            <Image source={process.env.PUBLIC_URL + '/assets/info.png'} style={styles.info} />
          </TouchableOpacity>
        </View>
        <Text style={styles.price}>
          {'\u20B9'}
          <Text style={styles.priceAmount}> {parseFloat(item.mrp).toFixed(2)}</Text>/month
        </Text>
        <View style={styles.responsiveDescription}>
          <View style={styles.sdcount}>
            <Image source={process.env.PUBLIC_URL + '/assets/check.png'} style={styles.check} />
            <Text style={styles.features}>{item.boxtype_lbl}</Text>
          </View>
        </View>
        <View style={{ justifyContent: 'center', alignItems: 'center', alignSelf: 'center', margin: 16 }}>
          <Text
            style={{ color: '#0092ed', borderBottomWidth: 1, borderBottomColor: '#0092ed'}}
            onClick={() => {
              getChannelList(item.id);
              setModalVisible(true);
            }}>
            View Channels
          </Text>
        </View>
        <TouchableOpacity 
          onPress={() => {
            selectThisPack(item);
          }}>
          {
            isSelected 
            ? <Button variant="success" style={{ backgroundColor: '#3C7F0E', borderColor: '#3C7F0E' }}>Selected</Button>
            : <Button variant="outline-light">Select</Button> 
          }  
        </TouchableOpacity>
        <Text style={styles.footer}>
          Network Capacity Fee extra as applicable
        </Text>
      </View>
    );
  };

  const renderChannelCard = ({item, index}) => {
    return (
      <View style={{ elevation: 8, borderWidth: 1, borderColor: 'grey', borderRadius: 8, flexDirection: 'column', width: isWeb ? '17%' : '45%', margin: 8, padding: 8 }}>
        {/* <Image source={{ uri: item.logo_url }} style={{ height: 90, width: 90}}/> */}
        <Text style={{ flex:1 }}>{item.name}</Text>
      </View>
    );
  }
  
  return (
    <View>
      <View style={styles.search}>
        <TextInput
          placeholder="Search..."
          style={styles.input}
          onChange={event => {
            searchItems(event.target.value)
          }}
        />
        <Image source={process.env.PUBLIC_URL + '/assets/search.png'} style={styles.searchIcon} />
      </View>
      {
        loading 
        ? 
        <ActivityIndicator size="large" />
        : 
        <>
        {
          channelPacks.length > 0
          ? (
            <FlatList
              style={{ alignSelf: 'center' }}
              data={channelPacks}
              numColumns={calculateNumOfColumns()}
              keyExtractor={item => item.id.toString()}
              renderItem={renderItem}
              extraData={selectedIds}
            />
          ) : (
            <Text style={{ color: 'white' }}>No AddOns packs are available.</Text>
          )
        }
        <Modal animationType="slide" transparent={true} visible={modalVisible}>
          <TouchableOpacity
            style={{ flex: 1 }} 
            activeOpacity={1} 
            onPressOut={() => {setModalVisible(false)}}>
            <View style={styles.modalContainer}>
              <View style={styles.modalBox}>
                <TouchableOpacity onPress={() => setModalVisible(false)}>
                  <Image source={process.env.PUBLIC_URL + '/assets/cancel.png'} style={styles.cancelIcon} />
                </TouchableOpacity>
                <Text style={styles.modalHeader}>{channelData.name || ''}</Text>
                <View style={styles.channelContainer}>
                { modalLoading 
                  ? (
                    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                      <Spinner animation="border" variant={'primary'}/>
                      <Text style={{ color: 'white', marginTop: 8 }}>Loading...</Text>
                    </View>
                    ) 
                  : (
                    <Accordion defaultActiveKey="0" style={{ width: '100%' }}>
                      {
                        channelList.map((obj) => {
                          return (
                            <Card key={obj.genre_id}>
                              <Accordion.Toggle as={Button} variant="Button" eventKey={obj.genre_id}>
                                {obj.genre_name}
                              </Accordion.Toggle>
                              <Accordion.Collapse eventKey={obj.genre_id}>
                                <FlatList
                                  showsHorizontalScrollIndicator={false}
                                  pagingEnabled={false}
                                  data={obj.channel_list}
                                  keyExtractor={item => item.id.toString()}
                                  renderItem={renderChannelCard}
                                  numColumns={isWeb ? 5 : 2}
                                />
                              </Accordion.Collapse>
                            </Card>
                          );
                        })
                      }
                    </Accordion>
                  )
                } 
                </View>
              </View>
            </View>
          </TouchableOpacity>
        </Modal>
      </>
      }
    </View>
  );
};

const styles = StyleSheet.create({
  search: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    backgroundColor: '#36353ca6',
    alignItems: 'center',
    padding: 10,
    borderRadius: 4,
    marginRight: 20,
    marginBottom: 30,
  },
  input: {
    width: 300,
    color: '#cdcddaf5',
  },
  searchIcon: {
    width: 15,
    height: 15,
    alignSelf: 'flex-end',
  },
  headerHolder: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  box: {
    width: 275,
    boxShadow: `${0}px ${0}px ${12}px ${'#8080803b'}`,
    padding: 20,
    margin: 16,
    borderRadius: 8,
    elevation: 8,
    backgroundColor: 'black'
  },
  boxHeader: {
    color: '#cdcddaf5',
    fontWeight: 400,
    letterSpacing: 1,
    fontSize: 13.4,
    marginRight: 4,
  },
  price: {
    alignSelf: 'center',
    marginTop: 25,
    fontSize: 16,
    color: '#0092ed',
  },
  priceAmount: {
    fontSize: 30,
  },
  desc: {
    flexDirection: 'row',
    marginTop: 5,
  },
  sdcount: {
    flexDirection: 'row',
    marginTop: 13,
  },
  check: {
    width: 14,
    height: 14,
    marginTop: 5,
    marginRight: 10,
  },
  features: {
    fontSize: 13,
    letterSpacing: 0.4,
    color: '#bcbbc7e6',
  },
  footer: {
    color: '#cdcddaf5',
    fontSize: 12,
    alignSelf: 'center',
    marginTop: 16,
  },
  responsiveDescription: {
    height: 70,
    justifyContent: 'center',
    paddingTop: 10,
  },
  button: {
    borderWidth: 1,
    borderColor: '#0092ed',
    alignSelf: 'center',
    marginVertical: 40,
    paddingHorizontal: 15,
    paddingVertical: 9,
    boxShadow: `${0}px ${1}px ${10}px ${'#8080803b'}`,
  },
  buttonText: {
    fontSize: 13,
    color: '#0092edc9',
    fontWeight: 'bold',
    letterSpacing: 1,
  },
  modalContainer: {
    backgroundColor: '#44444470',
    flex: 1,
  },
  modalBox: {
    backgroundColor: '#1a191f',
    borderRadius: 5,
    marginHorizontal: isWeb ? 250 : 15,
    marginTop: isWeb ? 40 : 15,
    padding: 20,
  },
  cancelIcon: {
    width: 20,
    height: 20,
    alignSelf: 'flex-end',
  },
  modalHeader: {
    alignSelf: 'center',
    fontSize: isWeb ? 17 : 13,
    letterSpacing: 1,
    color: '#cdcddaf5',
    fontWeight: 'bold',
  },
  channelContainer: {
    margin: 16,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  channel: {
    marginRight: 20,
    marginBottom: 20,
  },
  channelLogo: {
    width: 45,
    height: 45,
  },
  logoHolder: {
    borderColor: '#efefef1c',
    borderWidth: 1,
    alignItems: 'center',
    paddingHorizontal: 35,
    paddingVertical: 9,
  },
  channelName: {
    alignSelf: 'center',
    marginTop: 7,
    fontSize: 11,
    color: '#bcbbc7e6',
  },
  channelImage: {
    width: 100,
    height: 75,
    marginTop: 20,
    alignSelf: 'center',
  },
  info: {
    width: 16,
    height: 16,
    marginLeft: 8,
  },
  viewStyle: {
    height: HEIGHT,
  },
});

export default AddOnsListComponent;
